export class OwnerModel {
  constructor(
    public name: string,
    public id?: string,
  ) {}
}
